<template>
  <span class="wrapper">
    <span
      v-for="(status, i) in statuses"
      class="badge active"
      :class="{ [status.toLowerCase()]: true, 'has-more': statuses.length > 1, 'last': i === statuses.length - 1 }"
    >
      <a
        v-if="params.data['HasProcessedPayments']"
        target="_blank"
        :href="`${api.env}/PaymentInvoice/GetRemittancePdf?invoiceId=${params.data['Id']}`"
        title="Click for Remittance file"
      >
        {{ status }}
        <i v-if="i === statuses.length - 1" class="fal fa-file-alt"></i>
      </a>
      <span v-else>{{ status }}</span>
    </span>

    <i v-if="showRejectedTooltip"
      class="fas fa-question-circle"
      v-tooltip="{ content: fetchTooltip, loadingContent: '...' }"
    ></i>

  </span>
</template>

<script>

import {
  PENDING, SUBMITTED, APPROVED, DECLINED, PAID, PARTIALLY, REJECTED, OVERDUE
} from '@/components/_modules/Invoices/statuses'

const PendingOrApprovedOrSubmitted = status => ~[PENDING, SUBMITTED, APPROVED, OVERDUE].indexOf(status)

export default {
  data() {
    return {
      tooltip: '',
      PAID,
      PARTIALLY,
      SUBMITTED
    }
  },

  computed: {
    statuses() {
      const metaStatus = [ ...new Set([ ...this.paymentStatuses ]) ]
      return this.params.data
        ? metaStatus.some(PendingOrApprovedOrSubmitted) && metaStatus.filter(PendingOrApprovedOrSubmitted) || metaStatus
        : []
    },

    paymentStatuses() {
      return this.params.value ? this.params.value.replace(' - ', ' ').split(' ') : []
    },

    showRejectedTooltip() {
      return this.paymentStatuses[0] === DECLINED || this.paymentStatuses[1] === REJECTED
    }
  },

  methods: {
    async fetchTooltip() {
      if (this.tooltip) return this.tooltip

      const tooltip = await this.api.forms.post(this.api.$.invoice.rejectReason, {
        PaymentInvoiceID: this.params.data['PaymentInvoiceID'],
        gridID: this.params.context.alias
      })
      this.tooltip = tooltip.data || ''

      return tooltip.data
    }
  }
}

</script>

<style scoped lang='scss'>
@import "../statuses.scss";

.wrapper .badge {
  vertical-align: top;
  min-height: 0;
  padding: 3px 10px;

  &.active {
    &:after {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/cells/statuses.vue